var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.5H21.5V5.5H20V7V8.5ZM10 7H8.5C8.5 7.82843 9.17157 8.5 10 8.5V7ZM14 17V18.5C14.8284 18.5 15.5 17.8284 15.5 17H14ZM4 15.5H2.5V18.5H4V17V15.5ZM10 4H11.5V2.5H10V4ZM4 4V2.5H2.5V4H4ZM4 10H2.5V11.5H4V10ZM10 10V11.5H11.5V10H10ZM14 14V12.5H12.5V14H14ZM20 14H21.5V12.5H20V14ZM20 20V21.5H21.5V20H20ZM14 20H12.5V21.5H14V20ZM20 7V5.5H10V7V8.5H20V7ZM14 17V15.5H4V17V18.5H14V17ZM10 7H11.5V4H10H8.5V7H10ZM10 4V2.5H4V4V5.5H10V4ZM4 4H2.5V10H4H5.5V4H4ZM4 10V11.5H10V10V8.5H4V10ZM10 10H11.5V4H10H8.5V10H10ZM14 17H15.5V14H14H12.5V17H14ZM14 14V15.5H20V14V12.5H14V14ZM20 14H18.5V20H20H21.5V14H20ZM20 20V18.5H14V20V21.5H20V20ZM14 20H15.5V14H14H12.5V20H14Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.371a4e0fa743f634cfdce45cb81d0fb3.svg";
export { ForwardRef as ReactComponent };